const stopMobileSearchOverlayEvent = (event) => {
  event.stopPropagation();
};

export const MOBILE_SEARCH_OVERLAY_EVENT_HANDLERS = {
  onClick: stopMobileSearchOverlayEvent,
  onMouseDown: stopMobileSearchOverlayEvent,
  onPointerDown: stopMobileSearchOverlayEvent,
  onPointerMove: stopMobileSearchOverlayEvent,
  onPointerUp: stopMobileSearchOverlayEvent,
  onTouchStart: stopMobileSearchOverlayEvent,
  onTouchEnd: stopMobileSearchOverlayEvent,
};
